import axios from 'axios';
import Vue from 'vue'

export default {

    getNotifications (page, pageSize) {
        return axios.get('/api/notifications/list', { params: { page: page, pageSize: pageSize} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getInstantChatMsgCount() {
        return axios.get('/api/notifications/chat/count/')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getChatMsgCount(timestamp) {

        if (!timestamp) {timestamp = 0} 

        /*return axios.get('/api/notifications/chat/poll/' + timestamp, {timeout: 360000})
        .then(response => {
            if (response && response.data) return response.data
        })*/
    },
}

